import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

import i18n from "../../i18n";
import getAPIbaseURL from "../../utils/helpers";

const API_URL = `${getAPIbaseURL()}/shifts/schedule-types`;

export const fetchScheduleTypes = createAsyncThunk("scheduleTypes/fetch", async (_, thunkAPI) => {
  try {
    const response = await axios.get(API_URL, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});

export const updateScheduleTypes = createAsyncThunk("scheduleTypes/update", async (types, thunkAPI) => {
  try {
    const response = await axios.put(API_URL, { types }, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
    toast.success(i18n.t("components.TimePlanningTab.saved"));
    return response.data;
  } catch (error) {
    toast.error(i18n.t("components.TimePlanningTab.saveError"));
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});

const scheduleTypeSlice = createSlice({
  name: "scheduleTypes",
  initialState: { item: null, isLoading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchScheduleTypes.pending, (state) => { state.isLoading = true; })
      .addCase(fetchScheduleTypes.fulfilled, (state, action) => { state.isLoading = false; state.item = action.payload; state.error = null; })
      .addCase(fetchScheduleTypes.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })
      .addCase(updateScheduleTypes.pending, (state) => { state.isLoading = true; })
      .addCase(updateScheduleTypes.fulfilled, (state, action) => { state.isLoading = false; state.item = action.payload; state.error = null; })
      .addCase(updateScheduleTypes.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; });
  },
});

export default scheduleTypeSlice.reducer;
